module.exports = __webpack_public_path__ + "img/slideshow-premiere-couverture-ldb.d04f637c.png";